import React, { useState } from 'react'
import Container from 'components/Container'
import { getSigner } from 'utils'
import InputString from 'components/InputString'
import { CardBody, Button } from '@pancakeswap-libs/uikit'
// import { useTokenContract } from '../../hooks/useContract'
// import { AutoColumn } from 'components/Column'
// import { Contract } from 'ethers'
import { Link as HistoryLink } from 'react-router-dom'
import { RowBetween } from 'components/Row'
import { Contract } from 'ethers'
import { useTranslation } from 'react-i18next'
import useToast from 'hooks/useToast'
import { isAddress } from '../../utils'
import AppBody from '../AppBody'
import { Wrapper, Title, InputTitle, InputBox, WarnTip } from './styleds'
import Token_ABI from '../../constants/abis/erc20.json'
import { useActiveWeb3React } from '../../hooks'
import LOCK_ABI from '../../constants/abis/lock.json'
import { LockPlatformCoin } from '../../data/LockPlatformCoin'


export default function Register({match}) {
    const { lockAddress } = match.params
    const { t } = useTranslation()

    const { toastSuccess, toastError } = useToast()
    const { account, chainId, library } = useActiveWeb3React()
    const [tokenAddress, setTokenAddress] = useState('');
    const [tokenSymbol, setTokenSymbol] = useState('');
    const [isTrueAddress, setIsTrueAddress] = useState(false); 
    const [loading, setLoading] = useState(false); 
    
    const platformCoinSymbol = LockPlatformCoin(lockAddress)

    // const symbol = useSymbol(tokenAddress)
    // if(symbol) {
    //   setTokenSymbol(symbol)
    // }
    // const handleTokenAddress = useCallback(
    //   (value) => {
    //     const symbol = useSymbol(tokenAddress)
    //     setTokenAddress(value)
    //     setTokenSymbol('0x0913249bE694F0681aBcaa972DC8Cec03814f20b')
    //     setApplication('0x0913249bE694F0681aBcaa972DC8Cec03814f20b')
    //   },
    //   []
    // )
    const application = (account || '')
    const HandleNo = () => {
      // eslint-disable-next-line no-console
      console.log(1111)
    }
    const handleTokenAddress = async value => {
      // eslint-disable-next-line no-console
      console.log(22222222)
      if (!chainId || !library || !account) return
      // eslint-disable-next-line no-console
      console.log(111)
      setTokenAddress(value)
      const isAddr = isAddress(value)
      if(isAddr) {
        setIsTrueAddress(true)
      } else {
        setIsTrueAddress(false)
        return
      }
      // eslint-disable-next-line no-console
      console.log(isAddr, 'isAddr')
      if (!chainId || !library || !account) return
      const tokenContract = new Contract(value, Token_ABI, library)
      // // eslint-disable-next-line no-console
      // console.log(tokenContract, 'tokenContract')
      // tokenContract.symbol().then(res => {
      //   // eslint-disable-next-line no-console
      //   console.log(res, 'res')
      //   setTokenSymbol('eeee')
      // })
      try {
        const symbol = await tokenContract.symbol()
        setTokenSymbol(symbol)
      } catch (error) {
        setIsTrueAddress(false)
        setTokenSymbol('')
      }
      
    };
    const handleRegister = async () => {
     
      if (!chainId || !library || !account) return
       setLoading(true)
       try {
         const contract = new Contract(lockAddress, LOCK_ABI,getSigner(library, account))
         const tx = await contract.applyToken(tokenAddress, account)
         // eslint-disable-next-line no-console
        await tx.wait();
        toastSuccess(t('registration success'))
         setLoading(false)
       } catch {
        toastError(t('registration failed'))
         setLoading(false)
       }
     }
    return (
      <Container>
         <RowBetween marginBottom='30px' maxWidth="436px">
          <span>  </span>
          <HistoryLink style={{ color:'#29CAD5' }}  to={ `/register/list/${lockAddress}` }>{ t('Register record') }</HistoryLink>
        </RowBetween>
      <AppBody>
        <Wrapper>
          <Title>{ t('Contract Registration') }</Title>
         
          <CardBody>
             <InputBox>
               <InputTitle>{ t('Register token contract address') }</InputTitle>
               <InputString value={ tokenAddress } placeholder={ t('Please enter the token address') } onUserInput={ handleTokenAddress }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('Register Token Name') }</InputTitle>
               <InputString disabled value={ tokenSymbol } onUserInput={ HandleNo }/>
             </InputBox>
             <InputBox>
               <InputTitle>{ t('Application registrant wallet address') }</InputTitle>
               <InputString  disabled value={ application } onUserInput={ HandleNo }/>
             </InputBox>
             <WarnTip>
              { t('After the application is approved, the registered tokens will be able to participate in the airdrop of MEME coins.', { symbol: platformCoinSymbol }) }<br />
              { t('applyDesc', { symbol: platformCoinSymbol }) }
             </WarnTip>
             {!tokenAddress ? (
                <Button disabled width="100%">{ t('Enter token address') }</Button>
              ) : !isTrueAddress ? (
                <Button disabled width="100%">{ t('The address entered is incorrect') }</Button>
              ): (
                <Button width="100%" disabled={ loading } onClick={ handleRegister }>{ loading ? `${t('Register')}...` : t('Register')}</Button>
              )}
             
          </CardBody>
        </Wrapper>
      </AppBody>
    </Container>
    )
  }